/* RegularSection.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _13 = "._19pkl6l0{margin-top:var(--ds-space-300)}";
const _12 = "._i0dl1n8h{flex-basis:70%}";
const _11 = "._1o9zkb7n{flex-shrink:1}";
const _10 = "._16jlkb7n{flex-grow:1}";
const _9 = "@media (min-width:64rem){._isu4hiv4{margin-bottom:var(--ds-space-400)}}";
const _8 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7el6l0{margin-bottom:var(--ds-space-300)}}";
const _7 = "._otyrxjmg{margin-bottom:var(--ds-space-200)}";
const _6 = "._zulpxjmg{gap:var(--ds-space-200)}";
const _5 = "._4cvr1h6o{align-items:center}";
const _4 = "._1bah1yb4{justify-content:space-between}";
const _3 = "._1e0c1txw{display:flex}";
import { Hide, media, Show } from '@atlaskit/primitives/responsive';
import { BodyLarge, H3, LinkWithIcon } from '@atlassian/mpac-primitives';
import { useHistory } from '@atlassian/mpac-ui';
import React from 'react';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
const _2 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _ = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const Description = forwardRef((_ref, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1b66 _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Description.displayName = 'Description';
}
export const SectionHeader = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bah1yb4 _4cvr1h6o _zulpxjmg _otyrxjmg _1b7el6l0 _isu4hiv4", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SectionHeader.displayName = 'SectionHeader';
}
const HeaderDetails = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_10, _11, _12]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1n8h", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  HeaderDetails.displayName = 'HeaderDetails';
}
const LinkWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_13]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkl6l0", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  LinkWrapper.displayName = 'LinkWrapper';
}
export const RegularSection = _ref5 => {
  let {
    title,
    description,
    children,
    navigationUrl
  } = _ref5;
  const history = useHistory();
  const {
    tractExploreMoreAppClick
  } = useHomepageAnalytics();
  const navigationLinkClickHandler = event => {
    event.preventDefault();
    if (navigationUrl) tractExploreMoreAppClick(title, navigationUrl);
    history === null || history === void 0 ? void 0 : history.push(navigationUrl);
  };
  const ariaLabel = title.toLowerCase().includes('apps') ? "Explore more ".concat(title) : "Explore more ".concat(title, " apps");
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(HeaderDetails, null, /*#__PURE__*/React.createElement(H3, {
    as: "h2"
  }, title), description && /*#__PURE__*/React.createElement(Description, {
    "data-testid": "section-description"
  }, description)), navigationUrl && /*#__PURE__*/React.createElement(Show, {
    above: "sm"
  }, /*#__PURE__*/React.createElement(LinkWithIcon, {
    size: "medium",
    type: "internal",
    onClick: event => navigationLinkClickHandler(event),
    href: navigationUrl,
    "aria-label": ariaLabel
  }, "Explore more apps"))), /*#__PURE__*/React.createElement("div", null, children), navigationUrl && /*#__PURE__*/React.createElement(Hide, {
    above: "sm"
  }, /*#__PURE__*/React.createElement(LinkWrapper, null, /*#__PURE__*/React.createElement(LinkWithIcon, {
    size: "medium",
    type: "internal",
    onClick: event => navigationLinkClickHandler(event),
    href: navigationUrl,
    "aria-label": ariaLabel
  }, "Explore more apps"))));
};